import React from "react";
import styles from "./Banner.module.css";

export default function Banner() {
  return (
    <section className={styles.hero}>
      <div className={styles.container}>
        <div className={styles.heroText}>
          <h1>
            <span className={styles.accent}>Knowledge</span>
            <span className={styles.accent2}> Series </span>
            <br />
            <span className={styles.accent}>& </span>
            <span className={styles.accent2}> Events </span>
          </h1>
          <p>
            Discover cutting-edge research insights through our comprehensive
            knowledge series & transformative events
          </p>
          <div className={styles.heroActions}>
            <button className={`${styles.button} ${styles.orange}`}>
              View Upcoming Events
            </button>
            <button className={styles.button}>Explore Publications</button>
          </div>
        </div>
      </div>
    </section>
  );
}
